import api from './api';

export const toolService = {
  getAll: async (params = {}) => {
    const response = await api.get('/tools', { params });
    return response.data;
  },

  getById: async (id) => {
    const response = await api.get(`/tools/${id}`);
    return response.data;
  },

  create: async (data) => {
    const response = await api.post('/tools', data);
    return response.data;
  },

  update: async (id, data) => {
    const response = await api.put(`/tools/${id}`, data);
    return response.data;
  },

  delete: async (id) => {
    const response = await api.delete(`/tools/${id}`);
    return response.data;
  },

  assign: async (id, technicianId) => {
    const response = await api.put(`/tools/${id}/assign`, { technicianId });
    return response.data;
  },

  return: async (id) => {
    const response = await api.put(`/tools/${id}/return`);
    return response.data;
  },
};

export default toolService;
